import { lazy, Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import { Spin } from "antd";
import AppLayout from "@/components/AppLayout";

const Login = lazy(() => import("@/views/Login"));
const Setup = lazy(() => import("@/views/Setup"));
const Home = lazy(() => import("@/views/Home"));
const Projects = lazy(() => import("@/views/Projects"));
const Features = lazy(() => import("@/views/Features"));
const Products = lazy(() => import("@/views/Products"));
const ProductVersions = lazy(() => import("@/views/ProductVersions"));
const Versions = lazy(() => import("@/views/Versions"));
const Customers = lazy(() => import("@/views/Customers"));
const Issues = lazy(() => import("@/views/Issues"));
const Activations = lazy(() => import("@/views/Activations"));
const Statistics = lazy(() => import("@/views/Statistics"));
const Settings = lazy(() => import("@/views/Settings"));
const Backup = lazy(() => import("@/views/Backup"));
const Installations = lazy(() => import("@/views/Installations"));

const Loading = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
    }}
  >
    <Spin size="large" />
  </div>
);

export default function AppRouter() {
  return useRoutes([
    {
      path: "/login",
      element: (
        <Suspense fallback={<Loading />}>
          <Login />
        </Suspense>
      ),
    },
    {
      path: "/setup",
      element: (
        <Suspense fallback={<Loading />}>
          <Setup />
        </Suspense>
      ),
    },
    {
      path: "/",
      element: <AppLayout />,
      children: [
        {
          index: true,
          element: (
            <Suspense fallback={<Loading />}>
              <Home />
            </Suspense>
          ),
        },
        {
          path: "projects",
          element: (
            <Suspense fallback={<Loading />}>
              <Projects />
            </Suspense>
          ),
        },
        {
          path: "features",
          element: (
            <Suspense fallback={<Loading />}>
              <Features />
            </Suspense>
          ),
        },
        {
          path: "products",
          children: [
            {
              index: true,
              element: (
                <Suspense fallback={<Loading />}>
                  <Products />
                </Suspense>
              ),
            },
            {
              path: "versions",
              element: (
                <Suspense fallback={<Loading />}>
                  <ProductVersions />
                </Suspense>
              ),
            },
          ],
        },
        {
          path: "versions",
          element: (
            <Suspense fallback={<Loading />}>
              <Versions />
            </Suspense>
          ),
        },
        {
          path: "customers",
          element: (
            <Suspense fallback={<Loading />}>
              <Customers />
            </Suspense>
          ),
        },
        {
          path: "issues",
          element: (
            <Suspense fallback={<Loading />}>
              <Issues />
            </Suspense>
          ),
        },
        {
          path: "activations",
          element: (
            <Suspense fallback={<Loading />}>
              <Activations />
            </Suspense>
          ),
        },
        {
          path: "statistics",
          element: (
            <Suspense fallback={<Loading />}>
              <Statistics />
            </Suspense>
          ),
        },
        {
          path: "settings",
          element: (
            <Suspense fallback={<Loading />}>
              <Settings />
            </Suspense>
          ),
        },
        {
          path: "backup",
          element: (
            <Suspense fallback={<Loading />}>
              <Backup />
            </Suspense>
          ),
        },
        {
          path: "installations",
          element: (
            <Suspense fallback={<Loading />}>
              <Installations />
            </Suspense>
          ),
        },
      ],
    },
    { path: "*", element: <Navigate to="/" replace /> },
  ]);
}
